

















































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import Enrollment from '../../../api/v2/models/enrollment'
import Tag from '../../../api/v2/models/course_tag'
import api from '../../../api/v2/api'
import { headerState } from '../../stores/header'
import { checkMobile } from '../../utils/utils'
import CourseMy from '../atoms_molecules/CourseMy.vue'

@Component({
  components: {
    CourseMy
  }
})
export default class CourseList extends Vue {
  mobile = checkMobile()
  tags: Tag[] = [] 
  enrollments: Enrollment[] = []
  drawerRight = !this.mobile
  search = ''
  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: 'マイコース一覧',
      disabled: false,
      exact: true,
      to: '/classroom/my-courses'
    }
  ]

  page = 0
  isEnd = false
  loading = false
  config = {}

  async created() {
    headerState.setTitle('マイコース一覧')
    const listId = this.$route.query['tag'] as string
    await this.loadList(false, {tagId: listId})
    this.tags = await api.courseTag.my()
    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll(e) {
    if (this.$el.clientHeight + this.$el.scrollTop >= this.$el.scrollHeight) {
      this.loadList(true)
    }
  }

  async loadList(loadMore = false, config = undefined){
    if (this.loading) {
      return
    }

    if (!loadMore) {
      this.page = 0
      this.enrollments = []
      this.isEnd = false
      this.config = config || {}
    } else {
      if (this.isEnd) {
        return
      }
      this.page += 1
    }
    try {
      this.loading= true

      const more = await api.enrollment.index(this.config, this.page)
      this.enrollments = [...this.enrollments, ...more]

      if (more.length < 20) {
        this.isEnd = true
      }
    } finally {
      this.loading= false
    }
  }

  resetTag() {
    this.$router.push({ query: {} })
  }

  lessonId(course){
    return course.lessons[0].id
  }

  @Watch('search')
  async watchSearch(){
    const listId = this.$route.query['tag'] as string
    await this.loadList(false, {tagId: listId, search: this.search})
  }


  @Watch('$route', { immediate: true })
  async onChangeQueryRoute() {
    const listId = this.$route.query['tag'] as string
    await this.loadList(false, {tagId: listId})
  }
  setTag(id) {
    this.$router.push({ query: {tag: id} })
  }
}
